"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGlobalCSS = void 0;
var _core = require("@emotion/core");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1bwbz0n",
  styles: "*{box-sizing:border-box;}button::-moz-focus-inner{border:0;}"
} : {
  name: "1bwbz0n",
  styles: "*{box-sizing:border-box;}button::-moz-focus-inner{border:0;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2NvbnRleHQvR2xvYmFsQ1NTLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9FIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2NvbnRleHQvR2xvYmFsQ1NTLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbmltcG9ydCB7IFN0ZW5jaWxUaGVtZSB9IGZyb20gJ0BhbXpuL3N0ZW5jaWwtcmVhY3QtdGhlbWUtZGVmYXVsdCc7XG5cbi8vIHRoZW1lIHdpbGwgYmUgdXNlZCBoZXJlIGluIGZ1dHVyZVxuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby11bnVzZWQtdmFyc1xuZXhwb3J0IGNvbnN0IGdldEdsb2JhbENTUyA9ICh0aGVtZTogU3RlbmNpbFRoZW1lKSA9PlxuICBjc3Moe1xuICAgICcqJzoge1xuICAgICAgYm94U2l6aW5nOiAnYm9yZGVyLWJveCdcbiAgICB9LFxuICAgICdidXR0b246Oi1tb3otZm9jdXMtaW5uZXInOiB7XG4gICAgICBib3JkZXI6IDBcbiAgICB9XG4gIH0pO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

// theme will be used here in future
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getGlobalCSS = function getGlobalCSS(theme) {
  return _ref;
};
exports.getGlobalCSS = getGlobalCSS;